import React from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  IconButton,
  Text
} from "@chakra-ui/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

interface Props {
  previousPage: () => void;
  canPreviousPage: boolean;
  nextPage: () => void;
  canNextPage: boolean;
  currentPage: number;
  totalPages: number;
  gotoPage: ({ }: any) => void;
}

const Pagination: React.FC<Props> = ({
  previousPage,
  canPreviousPage,
  nextPage,
  canNextPage,
  currentPage,
  totalPages,
  gotoPage
}: Props) => {
  return (
    <Flex justifyContent="center" alignItems="center" w="full" fontSize={18}>
      <HStack spacing={2}>
        {canPreviousPage && (
          <IconButton
            onClick={() => previousPage()}
            aria-label="Previous page"
            size="md"
            variant="link"
            icon={<Icon as={FaChevronLeft} />}
          />
        )}
        {currentPage > 2 && (
          <HStack>
            <Button size="md" variant="link" onClick={() => gotoPage(0)}>
              1
            </Button>
            <Box>...</Box>
          </HStack>
        )}
        {currentPage > 1 && (
          <Button size="md" variant="link" onClick={() => previousPage()}>
            {currentPage - 1}
          </Button>
        )}
        <Text lineHeight="normal" color="blue.500" fontWeight={700}>
          {currentPage}
        </Text>
        {currentPage < totalPages && (
          <Button size="md" variant="link" onClick={() => nextPage()}>
            {currentPage + 1}
          </Button>
        )}
        {currentPage < totalPages - 1 && (
          <HStack>
            <Box>...</Box>
            <Button
              size="md"
              variant="link"
              onClick={() => gotoPage(totalPages - 1)}
            >
              {totalPages}
            </Button>
          </HStack>
        )}
        {canNextPage && (
          <IconButton
            onClick={() => nextPage()}
            aria-label="Next page"
            size="md"
            variant="link"
            icon={<Icon as={FaChevronRight} />}
          />
        )}
      </HStack>
    </Flex>
  );
};

export default Pagination;
